import { fetchAuthSession } from "aws-amplify/auth";
import { post, put, del } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import { CARENOTES_QUERY_KEY } from "./useCareNotesQuery";

export const useCareNotePostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "hrcarenotesapi",
        path: "/",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CARENOTES_QUERY_KEY] });
    },
  });
};

export const useCareNotePutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "hrcarenotesapi",
        path: "/",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CARENOTES_QUERY_KEY] });
    },
  });
};

export const useCareNoteDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: "hrcarenotesapi",
        path: "/",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: { id: id },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CARENOTES_QUERY_KEY] });
    },
  });
};
